import { get, last } from 'lodash';

function getExtension(file) {
  const fileName = get(file, 'name', '');
  return last(fileName.split('.')).toLowerCase();
}

export default getExtension;
